var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-group-popover" }, [
    _c(
      "div",
      { staticClass: "group-row" },
      [
        _c("label", [_vm._v(_vm._s(_vm.$t("tables.groupField")))]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticStyle: { width: "100%" },
            attrs: { placeholder: _vm.$t("tables.groupField") },
            model: {
              value: _vm.internalGroupField,
              callback: function ($$v) {
                _vm.internalGroupField = $$v
              },
              expression: "internalGroupField",
            },
          },
          _vm._l(_vm.groupableFields, function (field) {
            return _c(
              "a-select-option",
              { key: field._id, attrs: { value: field._id } },
              [
                _vm._v(
                  "\n                " + _vm._s(field.name) + "\n            "
                ),
              ]
            )
          }),
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "group-row" },
      [
        _c("label", [_vm._v(_vm._s(_vm.$t("tables.sortDirection")))]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticStyle: { width: "100%" },
            attrs: { placeholder: _vm.$t("tables.selectDirection") },
            model: {
              value: _vm.internalDirection,
              callback: function ($$v) {
                _vm.internalDirection = $$v
              },
              expression: "internalDirection",
            },
          },
          [
            _c("a-select-option", { attrs: { value: "asc" } }, [
              _vm._v(_vm._s(_vm.$t("tables.ascending"))),
            ]),
            _vm._v(" "),
            _c("a-select-option", { attrs: { value: "desc" } }, [
              _vm._v(_vm._s(_vm.$t("tables.descending"))),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "group-row switch-row" },
      [
        _c("label", [_vm._v(_vm._s(_vm.$t("tables.showEmptyGroups")))]),
        _vm._v(" "),
        _c("a-switch", {
          model: {
            value: _vm.internalShowEmpty,
            callback: function ($$v) {
              _vm.internalShowEmpty = $$v
            },
            expression: "internalShowEmpty",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "group-actions" },
      [
        _c(
          "a-button",
          { attrs: { type: "default" }, on: { click: _vm.onClearGroup } },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("tables.clearGrouping")) +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "a-button",
          { attrs: { type: "primary" }, on: { click: _vm.onApplyGroup } },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("tables.applyGrouping")) +
                "\n        "
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }